import * as React from "react";
import * as ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import { MuiThemeProvider } from "@material-ui/core";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "react-rangeslider/lib/index.css";
import "./common/i18n";
import "./index.css";

import i18n from "src/common/i18n";
import { Layout } from "src/common/components";
import { InstructionsProvider } from "src/common/contexts/Instructions/intructionsProvider";
import { LocalesProvider, LocalesContext } from "src/common/contexts";
import theme from "src/common/muiTheme/theme";
import Routes from "src/common/Routes";
import { initStore } from "src/helpers";
import Dashboard from "src/modules/Dashboard/view";
import store from "src/redux/configureStore";
import { unregister } from "./registerServiceWorker";
import TagManager from "react-gtm-module";
import { IS_PROD, TAG_MANAGER } from "src/config/env";

const tagManagerArgs = {
  gtmId: TAG_MANAGER
};

IS_PROD && TagManager.initialize(tagManagerArgs);

initStore().then(() => {
  ReactDOM.render(
    <React.StrictMode>
      <LocalesProvider>
        <InstructionsProvider>
          <I18nextProvider i18n={i18n}>
            <MuiThemeProvider theme={theme}>
              <Provider store={store}>
                <BrowserRouter>
                  <Layout>
                    <LocalesContext.Consumer>
                      {({ locales }) => {
                        const availableLocales = locales.join("|");
                        return (
                          <Switch>
                            <Route exact path={`/:lng(${availableLocales})/:view(login)`} component={Routes.LogIn} />
                            <Route
                              exact
                              path={`/:lng(${availableLocales})/:view(login-error)`}
                              component={Routes.LoginError}
                            />
                            <Route
                              path={`/:lng(${availableLocales})/dashboard/:view/:subView?`}
                              component={Dashboard}
                            />
                            <Route path="/" component={Routes.RedirectToMain} />
                          </Switch>
                        );
                      }}
                    </LocalesContext.Consumer>
                  </Layout>
                </BrowserRouter>
              </Provider>
            </MuiThemeProvider>
          </I18nextProvider>
        </InstructionsProvider>
      </LocalesProvider>
    </React.StrictMode>,
    document.getElementById("root") as HTMLElement
  );
});

Object.entries(Routes).forEach(([_, route]: any) => {
  if (route.preload) {
    route.preload();
  }
});

unregister();
